var _title, _rect, _path, _rect2, _rect3, _rect4, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _polygon, _ellipse, _ellipse2, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _ellipse3, _path17, _ellipse4, _path18, _ellipse5, _path19;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgAccomplishments = function SvgAccomplishments(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a8c3e3ad-ef53-4a9e-a620-842318013c49",
    "data-name": "Layer 1",
    viewBox: "0 0 967.85814 731.61295",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "done checking")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 259.07093,
    y: 558.29487,
    width: 207,
    height: 156,
    transform: "translate(301.6654 -178.16273) rotate(33.99519)",
    fill: "#f2f2f2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M226.9596,740.75385l-1.77734-.918c23.082-44.624,10.73925-102.5752-3.67872-143.332a439.29061,439.29061,0,0,0-37.27783-78.6748l1.69043-1.06836a441.53687,441.53687,0,0,1,37.47217,79.0752C237.93909,636.96577,250.36878,695.49507,226.9596,740.75385Z",
    transform: "translate(-116.07093 -84.19353)",
    fill: "#2f2e41"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 202.48076,
    y: 551.79519,
    width: 72.18033,
    height: 1.99936,
    transform: "matrix(0.17975, -0.98371, 0.98371, 0.17975, -464.17357, 603.9246)",
    fill: "#2f2e41"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 189.57057,
    y: 565.11916,
    width: 2.00072,
    height: 98.35141,
    transform: "translate(-483.48639 210.21597) rotate(-42.93968)",
    fill: "#2f2e41"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 233.06662,
    y: 679.79472,
    width: 58.00862,
    height: 2.00031,
    transform: "translate(-559.26439 410.14767) rotate(-54.13715)",
    fill: "#2f2e41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 134,
    cy: 404.10134,
    r: 10,
    fill: "#3f3d56"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 481.10134,
    r: 10,
    fill: "#3f3d56"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 491.10134,
    r: 10,
    fill: "#3f3d56"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 530.10134,
    r: 10,
    fill: "#3f3d56"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 174,
    cy: 555.10134,
    r: 10,
    fill: "#3f3d56"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 141,
    cy: 566.10134,
    r: 10,
    fill: "#3f3d56"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 164,
    cy: 598.10134,
    r: 10,
    fill: "#3f3d56"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 416.10134,
    r: 10,
    fill: "#3f3d56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M628.07093,751.29487c21.2135,22.74121-1.82288,102.24878-256,43-137.69354-32.09644-256-31.402-256-43s114.6151,1,256,1S620.15979,742.814,628.07093,751.29487Z",
    transform: "translate(-116.07093 -84.19353)",
    fill: "#3f3d56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M628.07093,751.29487c21.2135,22.74121-1.82288,102.24878-256,43-137.69354-32.09644-256-31.402-256-43s114.6151,1,256,1S620.15979,742.814,628.07093,751.29487Z",
    transform: "translate(-116.07093 -84.19353)",
    opacity: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M628.07093,751.29487c21.2135,22.74121-1.82288,80.24878-256,21-137.69354-32.09644-256-9.402-256-21s114.6151-21,256-21S620.15979,742.814,628.07093,751.29487Z",
    transform: "translate(-116.07093 -84.19353)",
    fill: "#3f3d56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M245.77111,159.10134H257.274A27.61206,27.61206,0,0,1,284.8861,186.7134v39.115a0,0,0,0,1,0,0h-66.727a0,0,0,0,1,0,0v-39.115a27.61206,27.61206,0,0,1,27.61206-27.61206Z",
    fill: "#2f2e41"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M355.39095,297.12293s2.7977,22.38159-3.49712,23.78044-9.09252,9.79194-9.09252,9.79194L363.784,343.98438l21.68217-4.19655-2.09828-16.08677s-5.59539-16.08676-2.7977-26.57813S355.39095,297.12293,355.39095,297.12293Z",
    transform: "translate(-116.07093 -84.19353)",
    fill: "#a0616a"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M355.39095,297.12293s2.7977,22.38159-3.49712,23.78044-9.09252,9.79194-9.09252,9.79194L363.784,343.98438l21.68217-4.19655-2.09828-16.08677s-5.59539-16.08676-2.7977-26.57813S355.39095,297.12293,355.39095,297.12293Z",
    transform: "translate(-116.07093 -84.19353)",
    opacity: 0.1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M327.414,556.60946l5.5954,36.37008s-1.39885,37.0695,8.3931,69.94246L351.1944,695.795l9.79194-11.19079L363.784,639.841s.69943-16.08677-2.09827-28.67641l2.09827-58.75167Z",
    transform: "translate(-116.07093 -84.19353)",
    fill: "#a0616a"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M379.17138,550.31464l4.896,63.64763s-2.09828,67.84419-2.7977,69.94247,13.98849,4.896,13.98849,4.896,22.38159-53.15627,15.38734-95.12175c0,0-4.19655-35.67065,1.39885-44.76317S379.17138,550.31464,379.17138,550.31464Z",
    transform: "translate(-116.07093 -84.19353)",
    fill: "#a0616a"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 251.21024,
    cy: 199.64033,
    r: 24.47986,
    fill: "#a0616a"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M347.69728,326.49876s2.7977,10.49137,16.08676,9.79195,19.58389-12.58965,19.58389-12.58965,16.08677,8.3931,23.78044,7.69367l-2.09827,34.27181s-13.28907,36.37008-10.49137,44.76317,59.45109,96.5206,52.45684,130.79241c0,0,6.99425,9.79194-19.58389,11.89021s-25.87871-2.79769-47.56087,6.99425-51.75742,4.19655-58.75167,2.7977-31.4741-5.5954-31.4741-5.5954S295.24043,453.794,327.414,418.82281l-.69942-62.94821-2.7977-23.78044s22.56743-11.19079,23.17393-8.3931Z",
    transform: "translate(-116.07093 -84.19353)",
    fill: "#2f2e41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M451.21212,373.36021s35.67065,22.38159,21.68216,31.47411-63.93085,32.00652-63.93085,32.00652-38.18514-18.018-28.3932-25.01228,26.57814,12.58965,26.57814,12.58965l43.36432-25.87871L439.3219,385.94985Z",
    transform: "translate(-116.07093 -84.19353)",
    fill: "#a0616a"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M305.7318,392.24468v102.116s-3.49712,39.16778,9.79195,36.37008,2.79769-37.76893,2.79769-37.76893L322.518,432.8113V399.23892Z",
    transform: "translate(-116.07093 -84.19353)",
    fill: "#a0616a"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M363.08462,667.818s-6.29482,13.28907-19.58389,5.5954c0,0,3.49712,11.89021,3.49712,14.68791s3.49713,17.48562,4.896,18.88447,0,32.17353,6.99424,33.57238,13.28907-16.08677,13.28907-22.38159-2.09828-26.57813-2.09828-26.57813,1.39885-13.28907-6.29482-17.48562Z",
    transform: "translate(-116.07093 -84.19353)",
    fill: "#2f2e41"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M399.4547,683.20531l-19.58389-2.7977-4.19655,16.78619S364.48347,727.26906,363.784,732.165s-13.28906,25.17929-2.09827,25.17929,22.38159.69942,24.47986-5.5954,6.29482-27.977,9.79195-35.67065-1.39885-15.38734-1.39885-15.38734Z",
    transform: "translate(-116.07093 -84.19353)",
    fill: "#2f2e41"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M400.85355,334.19243l6.29482-2.7977s6.29482,0,16.08676,11.1908,35.67066,33.57238,35.67066,33.57238-17.48562,17.48561-21.68216,16.08677-36.37008-32.17354-36.37008-32.17354Z",
    transform: "translate(-116.07093 -84.19353)",
    fill: "#2f2e41"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M327.414,332.09416h-3.49712s-14.68792,1.39885-16.78619,19.58389-5.5954,39.8672-6.99425,41.96547,18.185,11.1908,21.68217,11.1908,9.09252-54.55512,9.09252-54.55512Z",
    transform: "translate(-116.07093 -84.19353)",
    fill: "#2f2e41"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "269.403 188.506 235.713 188.506 228.086 170.976 275.124 170.976 269.403 188.506",
    fill: "#2f2e41"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 342.60801,
    cy: 281.18226,
    rx: 1.69645,
    ry: 4.52387,
    transform: "translate(-180.79305 22.27218) rotate(-16.16012)",
    fill: "#a0616a"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 391.31409,
    cy: 282.58111,
    rx: 4.52387,
    ry: 1.69645,
    transform: "translate(-105.08405 495.59124) rotate(-73.83988)",
    fill: "#a0616a"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 608.07093,
    y: 175.29487,
    width: 442,
    height: 254,
    transform: "matrix(0.87505, 0.48402, -0.48402, 0.87505, 133.83599, -447.71383)",
    fill: "#f2f2f2"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 448.87964,
    y: 181.56251,
    width: 147,
    height: 193,
    fill: "#539dfe"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 489.37964,
    y: 212.06251,
    width: 66,
    height: 66,
    fill: "#3f3d56"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 464.37964,
    y: 292.06251,
    width: 116,
    height: 8,
    fill: "#3f3d56"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 464.37964,
    y: 314.06251,
    width: 116,
    height: 8,
    fill: "#3f3d56"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 464.37964,
    y: 336.06251,
    width: 116,
    height: 8,
    fill: "#3f3d56"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 760.87964,
    y: 350.56251,
    width: 147,
    height: 193,
    fill: "#539dfe"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 782.37964,
    y: 376.06251,
    width: 104,
    height: 12,
    fill: "#3f3d56"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 782.37964,
    y: 402.06251,
    width: 104,
    height: 12,
    fill: "#3f3d56"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 782.37964,
    y: 428.06251,
    width: 104,
    height: 12,
    fill: "#3f3d56"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 782.37964,
    y: 454.06251,
    width: 104,
    height: 12,
    fill: "#3f3d56"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 782.37964,
    y: 480.06251,
    width: 104,
    height: 12,
    fill: "#3f3d56"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 782.37964,
    y: 506.06251,
    width: 104,
    height: 12,
    fill: "#3f3d56"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 717.87964,
    y: 25.56251,
    width: 147,
    height: 193,
    fill: "#539dfe"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 739.37964,
    y: 90.06251,
    width: 104,
    height: 12,
    fill: "#3f3d56"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 739.37964,
    y: 116.06251,
    width: 104,
    height: 12,
    fill: "#3f3d56"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 739.37964,
    y: 142.06251,
    width: 104,
    height: 12,
    fill: "#3f3d56"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 862.03454,
    cy: 25.36096,
    rx: 17.75167,
    ry: 17.78395,
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M978.10547,88.73976a21.21541,21.21541,0,1,0,21.21541,21.21541A21.27778,21.27778,0,0,0,978.10547,88.73976Zm-4.35528,32.52689-10.8729-10.8729L965.927,107.344l7.83338,7.83338,16.53374-16.53374,3.04971,3.04972-19.59365,19.57325Z",
    transform: "translate(-116.07093 -84.19353)",
    fill: "#57b894"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 908.03454,
    cy: 346.36096,
    rx: 17.75167,
    ry: 17.78395,
    fill: "#fff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1024.10547,409.73976a21.21541,21.21541,0,1,0,21.21541,21.21541A21.27778,21.27778,0,0,0,1024.10547,409.73976Zm-4.35528,32.52689-10.8729-10.8729,3.04972-3.04971,7.83338,7.83338,16.53374-16.53374,3.04971,3.04972-19.59365,19.57325Z",
    transform: "translate(-116.07093 -84.19353)",
    fill: "#57b894"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 596.03454,
    cy: 179.36096,
    rx: 17.75167,
    ry: 17.78395,
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M712.10547,242.73976a21.21541,21.21541,0,1,0,21.21541,21.21541A21.27778,21.27778,0,0,0,712.10547,242.73976Zm-4.35528,32.52689-10.8729-10.8729L699.927,261.344l7.83338,7.83338,16.53374-16.53374,3.04971,3.04972-19.59365,19.57325Z",
    transform: "translate(-116.07093 -84.19353)",
    fill: "#57b894"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAccomplishments, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/accomplishments.7b4bba8e.svg";
export { ForwardRef as ReactComponent };